<div class="container py-2 mx-auto">
  <div class="flex flex-wrap w-full mb-4">
    <div *ngIf="false" class="lg:w-1/2 w-full mb-6 lg:mb-0">
      <h1 id="youtube" class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-500">
        Subscribe to Our YouTube Channel
      </h1>
      <div class="h-1 w-20 bg-[#ff4d06] rounded"></div>
    </div>
    <p *ngIf="false" class="lg:w-1/2 w-full text-gray-500">
      Stay tuned for the latest updates and tech reviews:Unleash your inner tech
      guru! Subscribe to our YouTube channel for the latest tech updates,
      in-depth reviews, and expert insights to help you make informed decisions.
      Get notified first when new videos drop! Click YouTube icon and
      subscribe!!!
      <a href="https://www.youtube.com/@softnetgamers"
        class="text-red-600   rounded-md p-2 flex flex-row items-center justify-center gap-2"><span> Subscribe </span>
        <img src="../../../../assets/graphics/icons8-youtube.svg" alt="YouTube icon" style="width: 48px; object-fit: contain" /> <span> Our
          Channel </span> </a>
    </p>
    <a href="https://www.youtube.com/@softnettechnics"
      class="w-full h-40 bg-[#ff0000] flex flex-row  items-center justify-center relative md:p-6 md:py-0">
      <div src="../../../../assets/graphics/youtube-white.png"
        class="absolute top-0 left-0 w-full h-full right-0 bottom-0 "
        style=" background-repeat: repeat; background-size: 200px;"></div>
      <div class="w-full rounded-3xl   h-full relative items-center justify-center flex flex-col">

        <h1 class="ml4  flex flex-col items-center justify-center  text-center ">
          <span class="letters letters-1  text-sm md:text-3xl">SUBSCRIBE</span>
          <span class="letters letters-2  text-md md:text-2xl">To Our</span>
          <span class="letters letters-3 text-sm md:text-2xl "> <span class="">YouTube</span> Channel !</span>
        </h1>
      </div>
      <div
        class="bg-white rounded-2xl m-4 w-1/3 h-full flex items-center justify-center outline-offset-[16px] outline outline-[12px] outline-white p-2">
        <div
          class="bg-white rounded-2xl   w-full h-full flex items-center justify-center outline-offset-8 outline outline-[10px] outline-[#ff0000]">


          <img src="../../../../assets/graphics/youtube-logo.webp" alt="YouTube Logo" class="w-28 h-full object-contain" />
        </div>

      </div>

    </a>
  </div>
  <div class="flex flex-col w-full">
    <ngu-carousel *ngIf="vid[0] && vid[0].length > 0" #myCarousel [inputs]="carouselTile1" class="rounded-xl " [dataSource]="vid[0]">
      <ngu-tile *nguCarouselDef="let item; let i = index"
        class="p-1 relative hover:drop-shadow-lg rounded-lg aspect-video hover:border-4 hover:border-red-500 justify-center items-center">
        <a [href]="item.url" class="  grow w-full h-full">
          <img [src]="  getHost()+'/'+item.icon" [alt]="item.title || 'Video thumbnail'" class="aspect-video rounded-md !w-full !h-full !bg-cover bg-cover" />
          <div class="" style="height: 65px !important; min-height: 65px !important">
            <small class="text-sm !leading-3">{{ item.label }}</small>
          </div>
        </a>
      </ngu-tile>
    </ngu-carousel>

    <ngu-carousel *ngIf="vid[1] && vid[1].length > 0" #myCarousel2 [inputs]="carouselTile2" class="rounded-xl " [dataSource]="vid[1]">
      <ngu-tile *nguCarouselDef="let item; let i = index"
        class="p-1 relative hover:drop-shadow-lg rounded-lg aspect-video hover:border-4 hover:border-red-500 justify-center items-center">
        <a [href]="item.url" class="  grow w-full h-full">
          <img [src]="  getHost()+'/'+item.icon" [alt]="item.title || 'Video thumbnail'" class="aspect-video rounded-md !w-full !h-full !bg-cover bg-cover" />
          <div class="" style="height: 65px !important; min-height: 65px !important">
            <small class="text-sm !leading-3">{{ item.label }} </small>
          </div>
        </a>
      </ngu-tile>
    </ngu-carousel>

    <ngu-carousel *ngIf="shorts && shorts.length > 0" #myCarousel3 [inputs]="carouselTile3" class="rounded-xl" [dataSource]="shorts">
      <ngu-tile *nguCarouselDef="let item; let i = index"
        class="p-1 relative justify-stretch hover:drop-shadow-lg rounded-lg items-center aspect-[9/16] w-full h-full hover:border-4 hover:border-red-500">
        <a [href]="item.url" class="w-full h-full grow">
          <img [src]="  getHost()+'/'+item.icon" [alt]="item.title || 'Video thumbnail'" class="rounded-md !w-full !bg-cover aspect-[9/16]" />

          <div class="" style="height: 55px !important; min-height: 55px !important">
            <small>{{ item.label }}</small>
          </div>
        </a>
      </ngu-tile>
    </ngu-carousel>
  </div>